import { Component, ElementRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { RecordServiceSubject, RecordServiceFilter, RecordService } from 'src/app/services/record.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { CNItem } from 'src/app/models/cnitem';
import { first } from 'rxjs/operators';

export class RecordNode {
  name: string;
  children?: RecordNode[];
  record: CNItem;
}

@Component({
  selector: 'app-record-tree',
  templateUrl: './record-tree.component.html',
  styleUrls: [
    './record-tree.component.scss',
    '../../problem/problem-row/problem-row.component.scss',
    '../../medication/medication-row/medication-row.component.scss',
    '../../labo/labo-row/labo-row.component.scss',
    '../../protocol/protocol-row/protocol-row.component.scss'
  ]
})
export class RecordTreeComponent implements OnInit {

  public subject: RecordServiceSubject;
  private myLocation = 'default';
  private myFilter = RecordServiceFilter.all;

  @Input() pageSize = 30;

  treeControl = new NestedTreeControl<RecordNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<RecordNode>();

  constructor(public recordservice: RecordService) { }

  ngOnInit(): void {
    this.recordservice.clear.subscribe(flag => {
      console.log('records cleared');
    });
  }

  @Input() set location(theLocation: string) {
    this.myLocation = theLocation;
    this.subject = this.recordservice.getSubject(this.myLocation, this.myFilter, this.pageSize);
    this.subject.records.subscribe(data => {
      console.log('records', data);
      const TREE_DATA: RecordNode[] = [];
      const firstLevel: Map<string, RecordNode> = new Map();
      const orderedLevel: string[] = [];
      data.forEach(aRecord => {
        const levelName = aRecord.dateparts.year + '-' + aRecord.dateweek;
        if (!firstLevel.has(levelName)) {
          const newRecord = new RecordNode();
          newRecord.name = levelName;
          newRecord.children = [];
          firstLevel.set(levelName, newRecord);
          orderedLevel.push(levelName);
        }
        const recordLevel = firstLevel.get(levelName);
        const newChild = new RecordNode();
        newChild.name = this.recordType(aRecord);
        newChild.record = aRecord;
        recordLevel.children.push(newChild);
      });
      // Build tree
      orderedLevel.forEach(aLevel => {
        TREE_DATA.push(firstLevel.get(aLevel));
      });
      this.dataSource.data = TREE_DATA;
    });
  }

  recordType(record: CNItem): string {
    let type = '';
    switch (record.key) {
      case 'stvaast_protocol':
        type = 'Protocole';
        break;
      case 'stvaast_labo':
        type = 'Labo';
        break;
      case 'stvaast_consultation':
        type = 'Contact';
        break;
      case 'SNItem.CNItem.CNHealthProblem':
        type = 'Problème';
        break;
      case 'SNItem.CNItem.CNMedication':
        type = 'Traitement';
        break;
      }
    return type;
  }

  hasChild = (_: number, node: RecordNode) => !!node.children && node.children.length > 0;
}
